import { BillingApiFactory } from '@mynt/backoffice-api-spec/billables'
import Axios from 'api/axios'
import config from 'config'
import { mapCustomerBillingInfoToInvoice } from './mappers'

const billingApi = BillingApiFactory(undefined, config.boBaseUrl, Axios)

export const getInvoiceSummary = (customerId: string) =>
  billingApi.getCustomerBillingInfo(customerId).then(({ data }) => mapCustomerBillingInfoToInvoice(data))
